import { get, set } from 'lodash';

export const configMixin = (configs) => ({
  async beforeCreate() {
    const options = this.$options;

    if (options.parent && options.parent.$configs) {
      this.$configs = options.parent.$configs;
    } else {
      this.$configs = this.$_initConfig();

      Object.keys(configs).forEach((key) => this.$configs.set(key, configs[key]));
    }
  }
});

export const configPlugin = {
  install(Vue, configs = {}) {
    Vue.mixin({
      ...configMixin(configs)
    });

    Vue.prototype.$_initConfig = function () {
      const self = this;

      self.$_config = {};

      return {
        get(name = null) {
          return name ? get(self.$_config, name) : self.$_config;
        },

        set(name, value) {
          return set(self.$_config, name, value);
        }
      };
    };
  }
};

export default configPlugin;
